export var Namespace;
(function (Namespace) {
    Namespace["Account"] = "account";
    Namespace["Journeys"] = "journeys";
    Namespace["Pipelines"] = "pipelines";
    Namespace["Parcel"] = "parcel";
})(Namespace || (Namespace = {}));
export var Relation;
(function (Relation) {
    Relation["Edit"] = "edit";
    Relation["View"] = "view";
    Relation["Create"] = "create";
    Relation["Delete"] = "delete";
    Relation["Send"] = "send";
    Relation["SendTest"] = "send_test";
    Relation["Enable"] = "enable";
})(Relation || (Relation = {}));
export var GlobalResource;
(function (GlobalResource) {
    GlobalResource["Billing"] = "billing";
    GlobalResource["TeamMembers"] = "team_members";
    GlobalResource["Workspaces"] = "workspaces";
    GlobalResource["ApiCredentials"] = "api_credentials";
    GlobalResource["SupportAccess"] = "support_access";
    GlobalResource["CookieSettings"] = "cookie_settings";
})(GlobalResource || (GlobalResource = {}));
export var JourneysResource;
(function (JourneysResource) {
    JourneysResource["MessageSettings"] = "message_settings";
    JourneysResource["SendingOptions"] = "sending_options";
    JourneysResource["Campaigns"] = "campaigns";
    JourneysResource["Broadcasts"] = "broadcasts";
    JourneysResource["Newsletters"] = "newsletters";
    JourneysResource["TransactionalMessages"] = "transactional_messages";
    JourneysResource["InAppBroadcasts"] = "in_app_broadcasts";
    JourneysResource["People"] = "people";
    JourneysResource["ObjectTypes"] = "object_types";
    JourneysResource["Objects"] = "objects";
    JourneysResource["ObjectRelationships"] = "object_relationships";
    JourneysResource["Messages"] = "messages";
    JourneysResource["Forms"] = "forms";
    JourneysResource["SqlSyncs"] = "sql_syncs";
    JourneysResource["JsSnippets"] = "js_snippets";
    JourneysResource["SegmentIntegration"] = "segment_integration";
    JourneysResource["MParticleIntegration"] = "mParticle";
    JourneysResource["ReportingWebhooks"] = "reporting_webhooks";
    JourneysResource["AudiencesIntegration"] = "audiences_integration";
    JourneysResource["Logs"] = "logs";
    JourneysResource["Imports"] = "imports";
    JourneysResource["Exports"] = "exports";
    JourneysResource["Segments"] = "segments";
    JourneysResource["SubscriptionCenter"] = "subscription_center";
    JourneysResource["Collections"] = "collections";
    JourneysResource["Snippets"] = "snippets";
    JourneysResource["Layouts"] = "layouts";
    JourneysResource["EmailMessageSettings"] = "email_message_settings";
    JourneysResource["SlackMessageSettings"] = "slack_message_settings";
    JourneysResource["TwillioMessageSettings"] = "twillio_message_settings";
    JourneysResource["PushMessageSettings"] = "push_message_settings";
    JourneysResource["InAppMessageSettings"] = "in_app_message_settings";
    JourneysResource["LanguageSettings"] = "language_settings";
    JourneysResource["Assets"] = "assets";
    JourneysResource["MergeOptions"] = "merge_options";
    JourneysResource["WorkspaceSettings"] = "workspace_settings";
    JourneysResource["SensitiveData"] = "sensitive_data";
    JourneysResource["AttributeData"] = "attribute_data";
    JourneysResource["AttributeMetadata"] = "attribute_metadata";
    JourneysResource["TestEvents"] = "test_events";
    JourneysResource["AdAudience"] = "ad_audience";
    JourneysResource["Subscriptions"] = "subscriptions";
    JourneysResource["Suppressions"] = "suppressions";
    JourneysResource["Integrations"] = "integrations";
    JourneysResource["MetricExports"] = "metric_exports";
    JourneysResource["ConfiguredWebhooks"] = "configured_webhooks";
})(JourneysResource || (JourneysResource = {}));
export var PipelinesResource;
(function (PipelinesResource) {
    PipelinesResource["Sources"] = "sources";
    PipelinesResource["Destinations"] = "destinations";
    PipelinesResource["Suppressions"] = "suppressions";
    PipelinesResource["SensitiveData"] = "sensitive_data";
    PipelinesResource["AttributeData"] = "attribute_data";
})(PipelinesResource || (PipelinesResource = {}));
export var ParcelResource;
(function (ParcelResource) {
    ParcelResource["Emails"] = "emails";
    ParcelResource["Components"] = "components";
    ParcelResource["Previews"] = "previews";
})(ParcelResource || (ParcelResource = {}));
export const accountPermissions = Object.freeze([
    `${Namespace.Account}/${Relation.View}`,
    `${Namespace.Account}/${Relation.Edit}`,
    `${Namespace.Account}/${GlobalResource.Billing}/${Relation.View}`,
    `${Namespace.Account}/${GlobalResource.Billing}/${Relation.Edit}`,
    `${Namespace.Account}/${GlobalResource.TeamMembers}/${Relation.View}`,
    `${Namespace.Account}/${GlobalResource.TeamMembers}/${Relation.Edit}`,
    `${Namespace.Account}/${GlobalResource.Workspaces}/${Relation.Create}`,
    `${Namespace.Account}/${GlobalResource.ApiCredentials}/${Relation.View}`,
    `${Namespace.Account}/${GlobalResource.ApiCredentials}/${Relation.Edit}`,
    `${Namespace.Account}/${GlobalResource.SupportAccess}/${Relation.View}`,
    `${Namespace.Account}/${GlobalResource.SupportAccess}/${Relation.Edit}`,
    `${Namespace.Account}/${GlobalResource.CookieSettings}/${Relation.View}`,
    `${Namespace.Account}/${GlobalResource.CookieSettings}/${Relation.Edit}`,
    `${Namespace.Account}/${Namespace.Pipelines}/${Relation.Enable}`,
    `${Namespace.Account}/${Namespace.Journeys}/${Relation.Enable}`,
]);
export const workspacePermissions = Object.freeze([
    `${Namespace.Journeys}/${JourneysResource.WorkspaceSettings}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.WorkspaceSettings}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Imports}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Imports}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Imports}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Imports}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Exports}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Exports}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Exports}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Exports}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.MessageSettings}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.MessageSettings}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.SendingOptions}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.SendingOptions}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Campaigns}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Campaigns}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Campaigns}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Campaigns}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Broadcasts}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Broadcasts}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Broadcasts}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Broadcasts}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Newsletters}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Newsletters}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Newsletters}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Newsletters}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.TransactionalMessages}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.TransactionalMessages}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.TransactionalMessages}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.TransactionalMessages}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.InAppBroadcasts}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.InAppBroadcasts}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.InAppBroadcasts}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.InAppBroadcasts}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.People}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.People}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.People}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.People}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.ObjectTypes}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.ObjectTypes}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.ObjectTypes}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.ObjectTypes}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Objects}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Objects}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Objects}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Objects}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.ObjectRelationships}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.ObjectRelationships}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.ObjectRelationships}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.ObjectRelationships}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Forms}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Forms}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Forms}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Forms}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.SqlSyncs}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.SqlSyncs}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.SqlSyncs}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.SqlSyncs}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.JsSnippets}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.JsSnippets}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.JsSnippets}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.JsSnippets}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.SegmentIntegration}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.SegmentIntegration}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.SegmentIntegration}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.SegmentIntegration}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.MParticleIntegration}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.MParticleIntegration}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.ReportingWebhooks}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.ReportingWebhooks}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.AudiencesIntegration}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.AudiencesIntegration}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.AudiencesIntegration}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.AudiencesIntegration}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Messages}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Messages}/${Relation.Send}`,
    `${Namespace.Journeys}/${JourneysResource.TestEvents}/${Relation.Send}`,
    `${Namespace.Journeys}/${JourneysResource.Logs}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Segments}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Segments}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Segments}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Segments}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.SubscriptionCenter}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.SubscriptionCenter}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.SubscriptionCenter}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.SubscriptionCenter}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.SubscriptionCenter}/${Relation.Enable}`,
    `${Namespace.Journeys}/${JourneysResource.Collections}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Collections}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Collections}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Collections}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Snippets}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Snippets}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Snippets}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Snippets}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Layouts}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Layouts}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Layouts}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Layouts}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.EmailMessageSettings}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.EmailMessageSettings}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.EmailMessageSettings}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.EmailMessageSettings}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.SlackMessageSettings}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.SlackMessageSettings}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.SlackMessageSettings}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.SlackMessageSettings}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.TwillioMessageSettings}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.TwillioMessageSettings}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.TwillioMessageSettings}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.TwillioMessageSettings}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.PushMessageSettings}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.PushMessageSettings}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.PushMessageSettings}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.PushMessageSettings}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.InAppMessageSettings}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.InAppMessageSettings}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.InAppMessageSettings}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.InAppMessageSettings}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.LanguageSettings}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.LanguageSettings}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.LanguageSettings}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.LanguageSettings}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Assets}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Assets}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.Assets}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Assets}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.MergeOptions}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.SensitiveData}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.AttributeData}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.AttributeMetadata}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.AdAudience}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.AdAudience}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.AdAudience}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.AdAudience}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Subscriptions}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Suppressions}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Integrations}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.Integrations}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.Integrations}/${Relation.Delete}`,
    `${Namespace.Journeys}/${JourneysResource.Integrations}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.MetricExports}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.MetricExports}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.ConfiguredWebhooks}/${Relation.View}`,
    `${Namespace.Journeys}/${JourneysResource.ConfiguredWebhooks}/${Relation.Create}`,
    `${Namespace.Journeys}/${JourneysResource.ConfiguredWebhooks}/${Relation.Edit}`,
    `${Namespace.Journeys}/${JourneysResource.ConfiguredWebhooks}/${Relation.Delete}`,
    `${Namespace.Pipelines}/${PipelinesResource.Sources}/${Relation.View}`,
    `${Namespace.Pipelines}/${PipelinesResource.Sources}/${Relation.Create}`,
    `${Namespace.Pipelines}/${PipelinesResource.Sources}/${Relation.Edit}`,
    `${Namespace.Pipelines}/${PipelinesResource.Sources}/${Relation.Delete}`,
    `${Namespace.Pipelines}/${PipelinesResource.Destinations}/${Relation.View}`,
    `${Namespace.Pipelines}/${PipelinesResource.Destinations}/${Relation.Create}`,
    `${Namespace.Pipelines}/${PipelinesResource.Destinations}/${Relation.Edit}`,
    `${Namespace.Pipelines}/${PipelinesResource.Destinations}/${Relation.Delete}`,
    `${Namespace.Pipelines}/${PipelinesResource.Suppressions}/${Relation.View}`,
    `${Namespace.Pipelines}/${PipelinesResource.Suppressions}/${Relation.Create}`,
    `${Namespace.Pipelines}/${PipelinesResource.Suppressions}/${Relation.Delete}`,
    `${Namespace.Pipelines}/${PipelinesResource.SensitiveData}/${Relation.View}`,
    `${Namespace.Pipelines}/${PipelinesResource.AttributeData}/${Relation.View}`,
    `${Namespace.Parcel}/${ParcelResource.Emails}/${Relation.Create}`,
    `${Namespace.Parcel}/${ParcelResource.Emails}/${Relation.Edit}`,
    `${Namespace.Parcel}/${ParcelResource.Emails}/${Relation.Delete}`,
    `${Namespace.Parcel}/${ParcelResource.Emails}/${Relation.View}`,
    `${Namespace.Parcel}/${ParcelResource.Components}/${Relation.Create}`,
    `${Namespace.Parcel}/${ParcelResource.Components}/${Relation.Edit}`,
    `${Namespace.Parcel}/${ParcelResource.Components}/${Relation.Delete}`,
    `${Namespace.Parcel}/${ParcelResource.Components}/${Relation.View}`,
    `${Namespace.Parcel}/${ParcelResource.Previews}/${Relation.SendTest}`,
]);
export const permissions = Object.freeze([...accountPermissions, ...workspacePermissions]);
export function isValidPermission(maybePermission) {
    return permissions.includes(maybePermission);
}
export function isAccountPermission(maybePermission) {
    return accountPermissions.includes(maybePermission);
}
/**
 * Parse a permission string into its components
 * @param permission - Permission string like "journeys/campaigns/create"
 * @returns Object with namespace, resource, and relation (or null if invalid)
 */
export function parsePermission(permission) {
    const parts = permission.split('/');
    if (parts.length === 2) {
        // Format: namespace/relation (e.g., "account/view")
        const [namespace, relation] = parts;
        if (Object.values(Namespace).includes(namespace) &&
            Object.values(Relation).includes(relation)) {
            return {
                namespace: namespace,
                relation: relation,
            };
        }
    }
    else if (parts.length === 3) {
        // Format: namespace/resource/relation (e.g., "journeys/campaigns/create")
        const [namespace, resource, relation] = parts;
        if (Object.values(Namespace).includes(namespace) &&
            Object.values(Relation).includes(relation) &&
            (Object.values(JourneysResource).includes(resource) ||
                Object.values(PipelinesResource).includes(resource) ||
                Object.values(ParcelResource).includes(resource) ||
                Object.values(GlobalResource).includes(resource))) {
            return {
                namespace: namespace,
                resource: resource,
                relation: relation,
            };
        }
    }
    return null;
}
//# sourceMappingURL=index.js.map